export default (stroke) => `
    <svg width="17" height="31" viewBox="0 0 17 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L15.5 15.5L1 30" stroke="${stroke}"/>
    </svg>

    `;
